<template>
  <button class="art-guide-events-group-reorder-action" type="button" title="Reorder" v-on="$listeners">
    <ArtGuideEventDragIcon />
  </button>
</template>

<script>
import ArtGuideEventDragIcon from '@/components/artguide/ArtGuideEventDragIcon.vue';

export default {
  components: { ArtGuideEventDragIcon },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.art-guide-events-group-reorder-action {
  width: 24px;
  height: 24px;
  padding: 0;
  background-color: vars.$c-total-white;

  @media (min-width: vars.$mobile-break-point + 1px) {
    width: 32px;
    height: 32px;
  }

  &:hover {
    ::v-deep svg {
      path {
        stroke: vars.$c-dark-gray;
      }
    }
  }

  svg {
    width: 100%;
    height: 100%;
  }
}
</style>
